export type HeaderSearchType = 'product' | 'content' | 'none';

export function normalizeHeaderSearchSettings(
  searchType?: string | null,
  showSearch?: boolean | null
): { searchType: HeaderSearchType; showSearch: boolean } {
  const type = String(searchType || 'product').trim().toLowerCase();

  if (type === 'none' || showSearch === false) {
    return { searchType: 'none', showSearch: false };
  }

  if (type === 'content') {
    return { searchType: 'content', showSearch: showSearch ?? true };
  }

  return { searchType: 'product', showSearch: showSearch ?? true };
}

export function getHeaderSearchSaveFields(
  searchType?: string | null,
  showSearch?: boolean | null
): { searchType: HeaderSearchType; showSearchBar: boolean } {
  const normalized = normalizeHeaderSearchSettings(searchType, showSearch);
  return {
    searchType: normalized.searchType,
    showSearchBar: normalized.showSearch,
  };
}
